import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export var DownloadLink = function (_a) {
    var fileUrl = _a.fileUrl, fileName = _a.fileName;
    var linkRef = useRef(null);
    useEffect(function () {
        if (linkRef.current) {
            linkRef.current.click();
        }
    }, []);
    return (_jsxs("p", { children: [_jsx("a", { ref: linkRef, href: fileUrl, download: fileName, className: 'vas-text-primary hover:vas-underline', children: "Click here" }), _jsx("span", { children: " if the file is not downloaded automatically" })] }));
};
